module.exports = __webpack_public_path__ + "images/home/product/mobile/features-project-6494137de88d727c5e9938e0b375a0ec.png";